require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./interviste-ivo-trumpy.json") })
        }
      }, "path---interviste-ivo-trumpy");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---interviste-ivo-trumpy!./.cache/json/interviste-ivo-trumpy.json
// module id = 675
// module chunks = 231608221292675